export default "__VITE_ASSET__B3Xq$YU4__"